import { StyleSheet } from '@react-pdf/renderer';

import { themeColors } from '@/theme/colors';

export const PDFTextStyles = StyleSheet.create({
  containerTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    fontFamily: 'Montserrat',
    color: themeColors.primaryColor,
    marginBottom: 10,
  },
  title: {
    fontSize: 10,
    fontWeight: 'bold',
    fontFamily: 'Montserrat',
    color: '#0F1A1A',
  },
  subtitle: {
    fontSize: 6,
    fontFamily: 'Montserrat',
    paddingBottom: 10,
    color: '#767676',
  },
});
